import { useCallback } from "react";
import { useVoiceControl, VoiceButton } from "../voice/VoiceProvider";
import { heardAny } from "../voice/match";
import { useContent, useT } from "../i18n/LocaleProvider";

interface Props {
  onHome: () => void;
}

// Why drawing is great for kids — kid-friendly one-liners up top, with a fuller
// "For grown-ups" note below (same two-tier shape as the Privacy/Rules pages).
// The content lives in src/data/whyDrawing.ts, shared with the prerendered
// /why-drawing/ SEO page.

export function WhyDrawingPage({ onHome }: Props) {
  const t = useT();
  const { whyReasons, whyParentPoints } = useContent();
  const onCommand = useCallback(
    (transcript: string): boolean => {
      if (heardAny(transcript, [...t.commands.home, ...t.commands.back])) {
        onHome();
        return true;
      }
      return false;
    },
    [onHome, t],
  );
  useVoiceControl(onCommand);

  return (
    <div className="facts-page">
      <header className="player-header">
        <button className="home-btn" onClick={onHome} aria-label={t.backToHome}>
          {t.home}
        </button>
        <h1>{t.whyTitle}</h1>
      </header>

      <p className="subtitle">{t.whySubtitle}</p>

      <div className="control-bar">
        <VoiceButton />
      </div>

      <div className="facts-grid">
        {whyReasons.map((r, i) => (
          <div className="fact-card" key={i}>
            <div className="fact-emoji" aria-hidden="true">
              {r.emoji}
            </div>
            <p className="fact-text">{r.text}</p>
          </div>
        ))}
      </div>

      <div className="info-note">
        <p>
          <b>{t.forGrownUpsLead}</b> {t.whyIntro}
        </p>
        <ul>
          {whyParentPoints.map((p, i) => (
            <li key={i}>
              <b>{p.title}</b> {p.text}
            </li>
          ))}
        </ul>
        <p>{t.whyOutro}</p>
      </div>
    </div>
  );
}
